<div class="confirmation-requests"
	id="ConfirmationRequests">
	<button type="button" class="btn btn-primary"
		(click)="sendRequest()">{{'Onvio.Confirmations.SendConfirmationRequest' | translate}}</button>
</div>
